import React, { ReactNode } from 'react';
import Switcher from '../switcher/Switcher';
import { classNames } from '../utils/classNames';

// One setting that turns a behaviour on or off: an icon tile, a title, a short text and a large switch on the right.
// Blue by default; muted = gray, for a setting that cannot change now (pair it with disabled).
// The switch is controlled (checked) or uncontrolled (defaultChecked); onChange receives the next value.
type Props = {
	icon: ReactNode,
	title: ReactNode,
	description?: ReactNode,
	ariaLabel: string,
	checked?: boolean,
	defaultChecked?: boolean,
	onChange?: (checked: boolean) => void,
	disabled?: boolean,
	muted?: boolean,
};

const SwitchCard: React.FunctionComponent<Props> = ({
	icon,
	title,
	description,
	ariaLabel,
	checked,
	defaultChecked,
	onChange,
	disabled = false,
	muted = false,
}) => {
	return <div className={classNames('rounded-lg border p-4', muted ? 'border-gray-200 bg-gray-50' : 'border-blue-200 bg-blue-50')}>
		<div className="flex items-center justify-between gap-x-4">
			<div className="flex items-start gap-x-3">
				<div className={classNames('flex h-9 w-9 flex-none items-center justify-center rounded-lg text-white',
					muted ? 'bg-gray-400' : 'bg-blue-600')}>
					{icon}
				</div>
				<div>
					<h3 className="text-sm font-semibold text-gray-900">{title}</h3>
					{description !== undefined && <p className="mt-1 max-w-2xl text-xs text-gray-600">{description}</p>}
				</div>
			</div>
			<Switcher checked={checked} defaultChecked={defaultChecked} isLarge ariaLabel={ariaLabel} onChange={onChange}
								disabled={disabled} />
		</div>
	</div>;
};

export default SwitchCard;
